import { useCallback } from 'react';
import useSessionContext from './useSessionContext';

const useUserPermissions = () => {
  const {
    session: {
      user: { eap_access: EAPAccess }
    }
  } = useSessionContext();

  const userPermission = {
    menuKeys: [...new Set(EAPAccess?.map(({ menu_key: menuKey }) => menuKey))],
    routes: [...new Set(EAPAccess?.map(({ route_id: routeId }) => routeId))]
  };

  const hasPermission = useCallback(
    (checkType, checkAt, item) => {
      if (checkType !== 'EAP') {
        return true;
      }

      const key = checkAt === 'menuKeys' ? 'key' : 'id';
      return userPermission[checkAt].includes(item[key]);
    },
    [userPermission]
  );

  return {
    hasPermission
  };
};

export default useUserPermissions;
